import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';

interface RegionFormViewProps extends ComponentViewProps<RegionItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: RegionItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class RegionFormView extends React.Component<RegionFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) return null;

		const mode = this.props.mode;
		const displayNames = model.dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={this.props.mode}
							icon="book"
							title="General information">
							<Row>
								<Col xs={24}>
									<TabLanguageController model={this.props.model}
										dynamicProperties={array}
										mode={mode}
										setBusy={this.props.setBusy}
										isRichTextBox={false}
									/>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} lg={12}>
									<TextView mode={mode}
										label="Code"
										onGetErrorMessage={() => this.props.model.validate(false, 'code')}
										required value={model.code}
										onChanged={newVal => model.code = newVal}
									/>
								</Col>
								<Col xs={24} lg={12}>
									<TextView mode={mode}
										label="Code Iso2"
										onGetErrorMessage={() => this.props.model.validate(false, 'codeIso2')}
										value={model.codeIso2}
										onChanged={newVal => model.codeIso2 = newVal}
									/>
								</Col>
								<Col xs={24} lg={12}>
									<RegionEditorController
										label="Parent region"
										mode={mode}
										onChanged={(value) => { model.parentRegionId = value != null ? value.id : null }}
										value={model.parentRegionId}
										setBusy={this.props.setBusy}
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/regions/form/region-form.view.tsx